"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _BackendIssue = _interopRequireDefault(require("../model/BackendIssue"));

var _CreateOrUpdateSubstituteRuleRequest = _interopRequireDefault(require("../model/CreateOrUpdateSubstituteRuleRequest"));

var _Forbidden = _interopRequireDefault(require("../model/Forbidden"));

var _InternalServerError = _interopRequireDefault(require("../model/InternalServerError"));

var _ProviderType = _interopRequireDefault(require("../model/ProviderType"));

var _SubstituteRulePage = _interopRequireDefault(require("../model/SubstituteRulePage"));

var _Unauthorized = _interopRequireDefault(require("../model/Unauthorized"));

var _ValidationError = _interopRequireDefault(require("../model/ValidationError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* SubstituteRules service.
* @module api/SubstituteRulesApi
* @version 0.17
*/
var SubstituteRulesApi = /*#__PURE__*/function () {
  /**
  * Constructs a new SubstituteRulesApi. 
  * @alias module:api/SubstituteRulesApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function SubstituteRulesApi(apiClient) {
    _classCallCheck(this, SubstituteRulesApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Create or update substitute rules for products
   * **Scopes**: - `substitutes:write`  Try to update an existing Substitute rule within the product catalogue. If no existing rule are found, a new one will be created using the incoming request body. Otherwise, existing rules will be updated.  > If there is rules that exists but which are not bound to locations provided within the body, > they will be deleted from the product catalogue database.
   * @param {module:model/CreateOrUpdateSubstituteRuleRequest} createOrUpdateSubstituteRuleRequest 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  _createClass(SubstituteRulesApi, [{
    key: "createOrUpdateSubstituteRuleWithHttpInfo",
    value: function createOrUpdateSubstituteRuleWithHttpInfo(createOrUpdateSubstituteRuleRequest) {
      var postBody = createOrUpdateSubstituteRuleRequest; // verify the required parameter 'createOrUpdateSubstituteRuleRequest' is set

      if (createOrUpdateSubstituteRuleRequest === undefined || createOrUpdateSubstituteRuleRequest === null) {
        throw new Error("Missing the required parameter 'createOrUpdateSubstituteRuleRequest' when calling createOrUpdateSubstituteRule");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/substitute-rules', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create or update substitute rules for products
     * **Scopes**: - `substitutes:write`  Try to update an existing Substitute rule within the product catalogue. If no existing rule are found, a new one will be created using the incoming request body. Otherwise, existing rules will be updated.  > If there is rules that exists but which are not bound to locations provided within the body, > they will be deleted from the product catalogue database.
     * @param {module:model/CreateOrUpdateSubstituteRuleRequest} createOrUpdateSubstituteRuleRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "createOrUpdateSubstituteRule",
    value: function createOrUpdateSubstituteRule(createOrUpdateSubstituteRuleRequest) {
      return this.createOrUpdateSubstituteRuleWithHttpInfo(createOrUpdateSubstituteRuleRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a list of substitute rules
     * **Scopes**: - `substitutes:read`  Retrieve a list of Substitute rule that are stored inside product catalogue database. This list can be filtered by product or provider.
     * @param {String} locationUuid 
     * @param {Object} opts Optional parameters
     * @param {String} opts.productUuid 
     * @param {module:model/ProviderType} opts.providerType 
     * @param {String} opts.providerUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SubstituteRulePage} and HTTP response
     */

  }, {
    key: "listSubstituteRulesWithHttpInfo",
    value: function listSubstituteRulesWithHttpInfo(locationUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'locationUuid' is set

      if (locationUuid === undefined || locationUuid === null) {
        throw new Error("Missing the required parameter 'locationUuid' when calling listSubstituteRules");
      }

      var pathParams = {};
      var queryParams = {
        'location_uuid': locationUuid,
        'product_uuid': opts['productUuid'],
        'provider_type': opts['providerType'],
        'provider_uuid': opts['providerUuid']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SubstituteRulePage["default"];
      return this.apiClient.callApi('/substitute-rules', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a list of substitute rules
     * **Scopes**: - `substitutes:read`  Retrieve a list of Substitute rule that are stored inside product catalogue database. This list can be filtered by product or provider.
     * @param {String} locationUuid 
     * @param {Object} opts Optional parameters
     * @param {String} opts.productUuid 
     * @param {module:model/ProviderType} opts.providerType 
     * @param {String} opts.providerUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SubstituteRulePage}
     */

  }, {
    key: "listSubstituteRules",
    value: function listSubstituteRules(locationUuid, opts) {
      return this.listSubstituteRulesWithHttpInfo(locationUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return SubstituteRulesApi;
}();

exports["default"] = SubstituteRulesApi;